export default __webpack_public_path__ + "assets/ed52da6d991f2785791482196148856d.png";